import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectOperatorCompanies,
  selectOperatorCompaniesError,
  selectOperatorCompaniesIsLoading,
} from '../selectors/operator-companies.selectors';

@Injectable({ providedIn: 'root' })
export class OperatorCompaniesSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly companies = this._store.selectSignal(selectOperatorCompanies);
  public readonly isLoading = this._store.selectSignal(
    selectOperatorCompaniesIsLoading,
  );
  public readonly error = this._store.selectSignal(
    selectOperatorCompaniesError,
  );
}
